import styled from "styled-components";
import {Link} from "react-router-dom";

export const ThemedRelativeLink = styled(Link)`
    word-break: break-word;
    text-decoration: underline;
    color: ${({theme}) => theme.colors.universityColor};
    font-size: ${({theme}) => `${theme.TextBlock.sizes.small.fontSize}rem`};

    &:hover,
    &:focus {
        color: ${({theme}) => theme.colors.universityHoverColor};
    }
`;
